<template>
  <!-- Multiple items allowed -->
  <div
    v-if="!showOnlyOne"
    class="photo-wrapper"
  >
    <div
      v-for="(d, key) in data"
      :key="key"
      class="photo-container p-4 pb-6"
    >
      <a-image
        v-if="getType(d.media) === 'photo'"
        :src="getPhotoUrl(d.media)"
        :image-class="'photo object-cover rounded-lg w-300 h-200'"
        @click="() => openBaseModal('gallery', { images: [d.media], title: d.title })"
      />
      <div
        v-if="getType(d.media) === 'iframe-url'"
        @click="() => $emit('onIframeItemClicked', d.media?.url)"
      >
        <iframe
          class="rounded-lg"
          frameborder="0"
          allow="xr-spatial-tracking"
          :src="d.media?.url ?? d"
          width="300"
          height="200"
        />
      </div>
      <a-pdf-thumbnail
        v-if="getType(d.media) === 'pdf'"
        :id="`${d.title}_${key}`"
        :url="getPdfUrl(d.media)"
        :file="d"
        :image-class="'photo object-cover rounded-lg w-300 h-200'"
        @click="() => openBaseModal('pdf.view', { pdf: d.media })"
      />
   
      <!-- <a-pdf-thumbnail
        v-if="getType(d.media) === 'pdf'"
        :id="`${d.title}_${key}`"
        :url="getPdfUrl(d.media)"
        :file="d"
        :image-class="'photo object-cover rounded-lg w-300 h-200'"
        @click="() => 
          openBaseModal('gallery.pdf', {
            pdfs: mappedDokumentPhotos,
            title: 'Dokumente',
            downloadEnabled: true,
          })
        "
      /> -->
      <div
        v-if="d.title"
        class="mt-2 ml-2"
      >
        {{ d.title }}
      </div>
    </div>
    <div
      v-for="(item, key) in placeholderItems"
      :key="key"
      class="photo-container p-4"
    >
      <div
        class="w-300 h-200 rounded-lg flex items-center justify-center"
        style="background: #efefef"
      >
        {{ t("immobilie.platzhalterAufnahme") }}
      </div>
    </div>
  </div>

  

  <!-- One Video only -->
  <div
    v-else
    data-cy="immobilie-matterport"
  >
    <div
      class="p-3 iframe-video"
      @click="() => $emit('onIframeItemClicked', data[0].media?.url)"
    >
      <iframe
        class="rounded-lg"
        frameborder="0"
        allow="xr-spatial-tracking"
        :src="data[0].media?.url"
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { getPhotoUrl } from "@/utilities/get-media-url";
import { getPdfUrl } from '@/utilities/get-media-url';
import { IonImg } from "@ionic/vue";
import AImage from "@/components/Base/AImage";
import APdfThumbnail from "@/components/Base/APdfThumbnail";
import {computed} from "vue";
import PdfReader from "@/components/PdfReader/PdfReader.vue";
import useUser from '@/composables/useUser';
import { openBaseModal } from "@/modals/modal-helper";
// import APdfThumbnail from '../Base/APdfThumbnail.vue';

export default {
  name: "HorizontalImageScrolls",
  components: {
    AImage,
    IonImg,
    APdfThumbnail,
    PdfReader
  },
  props: {
    data:
    {
      type: Array,
      default: undefined
    },
    photoMode: {
      type: Boolean,
      default: true,
    },
    showMinItems: {
      type: Number,
      default: 3
    },
    showOnlyOne: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n({ useScope: 'global' });
    const user = useUser();
    const placeholderItems = computed(() => {

      if (!user.isImmobilienverwalter()) {
        let itemLength = 0;

        if (props.data) {
          if (Object.keys(props.data).length > 0) {
            // Object
            itemLength = Object.keys(props.data).length;
          } else {
            // Array
            itemLength = props.data.length
          }
        }

        if (itemLength < props.showMinItems) {
          const placeholderLength = props.showMinItems - itemLength;
          const arr = [];
          for (let i = 0; i < placeholderLength; i++) {
            arr.push({})
          }

          return arr;
        }
      }
      
      return [];
    })

    const getType = (d) => {
      if (!d) {
        return undefined;
      }

      if (d.ext === '.pdf' || d.ext === '.PDF') {
        return 'pdf';
      }

      if (d.ext === 'iframe') {
        return 'iframe-url'
      }

      return 'photo';
    }

    return {
      getPhotoUrl,
      getPdfUrl,
      placeholderItems,
      getType,
      openBaseModal,
      user,
      t
    }
  }
}
</script>

<style scoped>

.photo-wrapper {
  display: flex;
  overflow-x: auto;
}

.photo-container ~ .photo-container {
  padding-left: 0;
}

ion-img::part(image) {
  border-radius: 10px;
}

iframe {
  pointer-events: none;
}

.iframe-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.h-200 {
  height: 200px;
}
.w-300 {
  width: 300px;
}

</style>